"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogEntryPage = exports.ConnectedPressReleasePage = exports.DefaultPressReleasePage = void 0;
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const spa_core_1 = require("@episerver/spa-core");
const PageTop_1 = __importDefault(require("../Shared/PageTop"));
const Glossary_1 = __importDefault(require("../Shared/Glossary"));
const react_redux_1 = require("react-redux");
const foundation_settings_1 = require("@episerver/foundation-settings");
require("./PressReleasePage.scss");
const Link_1 = __importStar(require("app/Components/Common/Link"));
const date_utils_1 = require("app/utils/date.utils");
const GlossaryService_1 = __importDefault(require("app/Components/Common/GlossaryService"));
const LoadingSpinner_1 = __importDefault(require("app/Components/Shared/LoadingSpinner"));
const react_router_1 = require("react-router");
const DefaultPressReleasePage = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const ctx = (0, spa_core_1.useEpiserver)();
    const location = (0, react_router_1.useLocation)();
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const [categoryList, setCategoryList] = (0, react_1.useState)(settingsService.getContainerOnServer('Categories'));
    const language = props.currentLanguage;
    const originalDate = (_a = props.data.startPublish) === null || _a === void 0 ? void 0 : _a.toString();
    const [dateString, setDateString] = (0, react_1.useState)('');
    const title = ((_c = (_b = props.data) === null || _b === void 0 ? void 0 : _b.releaseTitle) === null || _c === void 0 ? void 0 : _c.value) + ' | Sampo.com' || (typeof ((_d = props.data) === null || _d === void 0 ? void 0 : _d.name) === 'string' ? props.data.name : (_f = (_e = props.data) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.value);
    const categoryItems = [];
    const attachments = [];
    let mainBody = (_g = props.data.mainBody) === null || _g === void 0 ? void 0 : _g.value;
    let isNewsArticle = false;
    const customRegex = !layoutSettings ? '' : typeof ((_h = layoutSettings.pressreleaseRegex) === null || _h === void 0 ? void 0 : _h.value) === 'string' ? layoutSettings.pressreleaseRegex.value : layoutSettings.pressreleaseRegex;
    let customPattern;
    if (customRegex && customRegex !== '')
        customPattern = new RegExp(customRegex.toString(), 'g');
    const pattern = new RegExp('<table>', 'g');
    const patternStart = new RegExp('<table style="(.*?)">|<table class="(.*?hugin.*?) style=".*?">|<table class="(.*?responsive.*?)">', 'g');
    const patternEnd = new RegExp('</table>', 'g');
    if (mainBody && mainBody.indexOf('<div class="scrollable">') === -1) {
        mainBody = mainBody.replace(pattern, '<div class="scrollable"><table>');
        mainBody = mainBody.replace(patternStart, '<div class="scrollable"><table>');
        mainBody = mainBody.replace(patternEnd, '</table></div>');
        if (customPattern)
            mainBody = mainBody.replace(customPattern, '<div class="scrollable"><table>');
        props.data.mainBody.value = mainBody;
    }
    const categories = [].slice.call((_j = props.data.categories) === null || _j === void 0 ? void 0 : _j.value);
    if (categories && categories.length > 0) {
        categories.sort(function (a, b) {
            try {
                if (a.id < b.id) {
                    return -1;
                }
                if (a.id > b.id) {
                    return 1;
                }
                return 0;
            }
            catch (_a) {
                //ignore on purpose
            }
        });
        const releaseCat = categoryList === null || categoryList === void 0 ? void 0 : categoryList.categories.find(cat => cat.type === 'Release');
        const newsCat = categoryList === null || categoryList === void 0 ? void 0 : categoryList.categories.find(cat => cat.type === 'NewsArticle' || cat.type === 'SustainabilityArticle');
        categories.forEach((x) => {
            if (categoryList !== undefined && x.id.toString() !== releaseCat.id) {
                if (!isNewsArticle && newsCat.id === x.id.toString()) {
                    isNewsArticle = true;
                }
                const categoryItem = categoryList.categories.find(cat => cat.id === x.id.toString());
                const name = categoryItem.displayTexts.find(text => text.language === language).displayText;
                categoryItems.push(react_1.default.createElement("span", { className: 'pe-2 d-inline-block ', key: 'category' + x.id.toString() },
                    categoryItems.length > 0 && ' / ',
                    name || ''));
            }
        });
    }
    [].slice.call((_k = props.data.attachments) === null || _k === void 0 ? void 0 : _k.value).forEach((x) => {
        var _a, _b, _c;
        const target = ((_a = x === null || x === void 0 ? void 0 : x.target) === null || _a === void 0 ? void 0 : _a.value) === '_blank' ? Link_1.LinkTarget.New_window : Link_1.LinkTarget.Current_window;
        attachments.push(react_1.default.createElement("div", { className: 'col-12 col-sm-6 mb-4', key: x === null || x === void 0 ? void 0 : x.href },
            react_1.default.createElement(Link_1.default, { href: x === null || x === void 0 ? void 0 : x.href, documentType: (_b = x === null || x === void 0 ? void 0 : x.href) === null || _b === void 0 ? void 0 : _b.substring(((_c = x === null || x === void 0 ? void 0 : x.href) === null || _c === void 0 ? void 0 : _c.lastIndexOf('.')) + 1, x === null || x === void 0 ? void 0 : x.href.length), target: target, title: x === null || x === void 0 ? void 0 : x.title, type: Link_1.LinkType.Document_liftup_icon, download: true })));
    });
    const addTableScrollIndicators = () => {
        const tables = document.querySelectorAll('.scrollable table');
        tables.forEach(table => {
            const scrollWrapper = table.closest('.scrollable');
            const maxScroll = table.scrollWidth - scrollWrapper.clientWidth;
            scrollWrapper.classList.remove('left');
            scrollWrapper.classList.remove('right');
            if (scrollWrapper.scrollLeft < maxScroll)
                scrollWrapper.classList.add('right');
            if (scrollWrapper.scrollLeft > 0)
                scrollWrapper.classList.add('left');
        });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        let isCancelled = false;
        settingsService.getContainer('LayoutSettings').then(x => {
            if (isCancelled)
                return;
            setLayoutSettings(x);
        });
        settingsService.getContainer('LabelSettings').then(x => {
            if (isCancelled)
                return;
            setLabelSettings(x);
        });
        settingsService.getContainer('Categories').then(x => {
            if (isCancelled)
                return;
            setCategoryList(x);
        });
        setDateString(isNewsArticle ? (0, date_utils_1.getFormatedGeneralDate)(originalDate, props.data.language.name, true) : (0, date_utils_1.getFormatedGeneralDatetime)(originalDate, (_a = props.data.language) === null || _a === void 0 ? void 0 : _a.name, true));
        const scrollables = document.querySelectorAll('.scrollable');
        scrollables.forEach((el) => {
            el.addEventListener('scroll', addTableScrollIndicators);
        });
        window.addEventListener('resize', addTableScrollIndicators);
        return () => {
            isCancelled = true;
            window.removeEventListener('resize', addTableScrollIndicators);
            const scrollables = document.querySelectorAll('.scrollable');
            scrollables.forEach((el) => {
                el.removeEventListener('scroll', addTableScrollIndicators);
            });
        };
    }, [language]);
    (0, react_1.useEffect)(() => {
        if (!ctx.isInEditMode() && document.activeElement.id !== 'contentRow')
            document.querySelector('h1').focus({ preventScroll: true });
    }, [props.contentLink.id]);
    if (!layoutSettings || !labelSettings || !categoryList)
        return react_1.default.createElement(LoadingSpinner_1.default, null);
    const toReleasepage = `${((_l = layoutSettings.releaseSearchPageUrl) === null || _l === void 0 ? void 0 : _l.value) || props.data.parentLink.url}${location.search}`;
    const langtags = [];
    ((_m = props.data.existingLanguages) === null || _m === void 0 ? void 0 : _m.length) > 1 &&
        props.data.existingLanguages.forEach(l => {
            langtags.push(react_1.default.createElement("link", { href: l.link, hrefLang: l.name, rel: "alternate", key: l.name }));
        });
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("link", { rel: "canonical", href: props.data.url }),
            react_1.default.createElement("meta", { property: "og:url", content: window.location.href }),
            react_1.default.createElement("meta", { property: "og:type", content: "website" }),
            react_1.default.createElement("meta", { property: "og:title", content: title }),
            ((_p = (_o = layoutSettings.facebookShareImage) === null || _o === void 0 ? void 0 : _o.value) === null || _p === void 0 ? void 0 : _p.url) &&
                react_1.default.createElement("meta", { property: "og:image", content: layoutSettings.facebookShareImage.value.url }),
            ((_r = (_q = layoutSettings.twitterShareImage) === null || _q === void 0 ? void 0 : _q.value) === null || _r === void 0 ? void 0 : _r.url) &&
                react_1.default.createElement("meta", { property: "twitter:image", content: layoutSettings.twitterShareImage.value.url }),
            react_1.default.createElement("meta", { name: "twitter:card", content: "summary" }),
            ((_s = props.data.existingLanguages) === null || _s === void 0 ? void 0 : _s.length) > 1 &&
                react_1.default.createElement("link", { href: props.data.url, hrefLang: "x-default", rel: "alternate" }),
            ((_t = props.data.existingLanguages) === null || _t === void 0 ? void 0 : _t.length) > 1 && langtags),
        react_1.default.createElement("main", Object.assign({ className: 'page position-relative' }, (((_u = props.data.releaseLanguage) === null || _u === void 0 ? void 0 : _u.value) !== '' ? { lang: (_v = props.data.releaseLanguage) === null || _v === void 0 ? void 0 : _v.value } : null), { tabIndex: -1 }),
            react_1.default.createElement(PageTop_1.default, { layoutSettings: layoutSettings, showNews: false, breadCrumbsProps: props.data, fontWhite: false, lang: language }),
            react_1.default.createElement(Glossary_1.default, { labelSettings: labelSettings, useGlossary: true, useShare: true }),
            react_1.default.createElement("div", { className: 'row g-0 press-release-page' },
                react_1.default.createElement("div", { className: 'block layout col-12 d-none d-sm-block' },
                    react_1.default.createElement("div", { className: 'mt-9 mt-md-10 pt-md-10' },
                        react_1.default.createElement("div", { className: 'row' },
                            react_1.default.createElement("div", { className: 'col-12 text-md-end' },
                                react_1.default.createElement("a", { className: 'link iconFront', href: toReleasepage },
                                    react_1.default.createElement("span", { className: 'icon-arrow-left-tail pe-3' }),
                                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'showAllReleases' })))))),
                react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                    react_1.default.createElement("div", { className: 'mt-7' },
                        react_1.default.createElement("div", { className: 'row' },
                            react_1.default.createElement("div", { className: 'col-12' },
                                react_1.default.createElement("h1", { className: 'mb-6 mb-sm-2 no-outline', tabIndex: -1 },
                                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "releaseTitle" })),
                                react_1.default.createElement("div", { className: 'release-detail mb-9 mb-sm-7' },
                                    categoryItems,
                                    react_1.default.createElement("span", { className: 'd-inline-block pe-2' }, "|"),
                                    react_1.default.createElement("span", { className: 'd-inline-block blog-date' }, dateString)))),
                        react_1.default.createElement("div", { className: 'row' },
                            react_1.default.createElement("div", { className: 'col-12', "data-glenabled": true },
                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "mainBody" }))),
                        attachments.length > 0 &&
                            react_1.default.createElement("div", { className: 'row pb-9 pb-sm-10' }, attachments))),
                react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: 'row' },
                            react_1.default.createElement("div", { className: 'col-12' },
                                react_1.default.createElement("div", { className: 'border-light-gray border-bottom' }))))),
                react_1.default.createElement("div", { className: 'block layout r-narrow col-12' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: 'row' },
                            react_1.default.createElement("div", { className: 'col-12 my-8 my-sm-9' },
                                react_1.default.createElement("a", { className: 'link iconFront', href: props.data.parentLink.url },
                                    react_1.default.createElement("span", { className: 'icon-arrow-left-tail pe-3' }),
                                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'showAllReleases' })))))))),
        react_1.default.createElement(GlossaryService_1.default, { glossaryActive: props.glossaryOpen, settings: layoutSettings }));
};
exports.DefaultPressReleasePage = DefaultPressReleasePage;
exports.ConnectedPressReleasePage = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(exports.DefaultPressReleasePage);
const BlogEntryPage = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    if (ctx.isServerSideRendering())
        return react_1.default.createElement(exports.DefaultPressReleasePage, Object.assign({}, props));
    return react_1.default.createElement(exports.ConnectedPressReleasePage, Object.assign({}, props));
};
exports.BlogEntryPage = BlogEntryPage;
exports.default = exports.BlogEntryPage;
